import React, { useState, useRef, useContext } from 'react';
import { PropiedadContext } from '../context/propiedades/propiedadesContext';
import Swal from 'sweetalert2';

function ThumbnailUpload({ idCasa, thumbnailUrl, onUpdateComplete }) {
    const [isEditing, setIsEditing] = useState(false);
    const fileInputRef = useRef(null);

    const { updateThumbnail, loading } = useContext(PropiedadContext);

    const handleEditClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            Swal.fire('Error', 'El archivo debe ser una imagen', 'error');
            return;
        }

        const isValidSize = file.size <= 5 * 1024 * 1024; // 5MB
        if (!isValidSize) {
            Swal.fire('Error', 'La imagen no debe superar los 5MB', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('thumbnail', file);

        try {
            await updateThumbnail(idCasa, formData);
            Swal.fire('Listo', 'Thumbnail actualizado correctamente', 'success');
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            if (onUpdateComplete) {
                onUpdateComplete();
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudo actualizar el thumbnail', 'error');
        }
    };

    return (
        <div className='d-flex align-items-center gap-2'>
            <div className='position-relative' style={{ width: '100px', height: '100px' }}>
                <img
                    src={thumbnailUrl || 'https://via.placeholder.com/40'}
                    alt='Thumbnail'
                    className='rounded'
                    style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        border: '1px solid #ddd'
                    }}
                />
            </div>
            <button
                type='button'
                className='btn btn-sm btn-outline-primary'
                onClick={handleEditClick}
                disabled={loading}
            >
                <i className='fas fa-edit'></i> {loading ? 'Actualizando...' : 'Editar'}
            </button>
            <input
                ref={fileInputRef}
                type='file'
                accept='image/*'
                hidden
                onChange={handleFileChange}
            />
        </div>
    );
}

export default ThumbnailUpload;
